'use strict';

var _themeSections = require('@shopify/theme-sections');

var _micromodal = require('micromodal');

var _micromodal2 = _interopRequireDefault(_micromodal);

var _jsCookie = require('js-cookie');

var Cookies = _interopRequireWildcard(_jsCookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
    mobileLink: "[data-newsletter-link]",
    modal: "[data-newsletter]",
    title: "[data-newsletter-title]",
    form: "[data-newsletter-form]"
};

(0, _themeSections.register)('newsletter-popup', {
    onLoad: function onLoad() {
        var modal = document.querySelector(selectors.modal);
        var form = document.querySelector(selectors.form);
        var popupRemember = parseInt(modal.getAttribute("data-remember-me"));
        var popupDelay = parseInt(modal.getAttribute("data-delay"));

        if (Cookies.get('newsletter') != "shown") {
            setTimeout(function () {
                _micromodal2.default.show('modal-newsletter');
            }, popupDelay);
        }

        Cookies.set('newsletter', 'shown', { expires: popupRemember });

        if (location.hash == "#newsletter-success" || location.hash == "#newsletter-error") {
            if (location.hash == "#newsletter-success") {
                modal.querySelector(selectors.title).innerHTML = window.theme.strings.newsletterThankYou;
            }
            if (location.hash == "#newsletter-error") {
                modal.querySelector(selectors.title).innerHTML = window.theme.strings.newsletterError;
            }
            form.classList.add("hidden");

            _micromodal2.default.show('modal-newsletter');
            document.querySelector(selectors.mobileLink).parentElement.classList.add("hidden");
            modal.classList.remove("hidden");

            setTimeout(function () {
                _micromodal2.default.close('modal-newsletter');
                location.hash = "";
            }, 5000);
        }

        document.querySelector(selectors.mobileLink).addEventListener("click", function () {
            this.parentElement.classList.add("hidden");
            modal.classList.remove("hidden");
        });
    },

    onSelect: function onSelect(event) {
        _micromodal2.default.show('modal-newsletter');
    },

    onDeselect: function onDeselect(event) {
        _micromodal2.default.close('modal-newsletter');
    }

});